export default {
    table: {
        clickModify: true,
        selectBtn: true,
        leftOperation: true,
        leftWidth: 160,
        height: 250,
        columns: [
            {
                label: '专线账号',
                prop: 'lineAccount',
                sort: true,
                width: 150
            },
            {
                label: '专线key',
                prop: 'lineKey',
                sort: true
            },
            {
                label: '平台类型',
                prop: 'lclPlate',
                sort: true,
                width: 150
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [
            10,
            20,
            30,
            50
        ]
    }
};
